import { combineReducers } from "redux";

import * as isLedgerContextLoading from "./isLedgerContextLoading";
import * as ledgerContext from "./ledgerContext";
import * as isLedgerActivityLoading from "./isLedgerActivityLoading";
import * as ledgerActivity from "./ledgerActivity";
import * as transactionId from "./transactionId";
import * as pdpPointsTotal from "./pdpPointsTotal";
import * as isPDPPointsTotalLoading from "./isPDPPointsTotalLoading";
import * as loyaltyQuestToken from "./loyaltyQuestRequestToken";
import * as isLoyaltyQuestTokenLoading from "./isLoyaltyQuestRequestTokenLoading";

export const initialState = {
  isLedgerContextLoading: isLedgerContextLoading.initialState,
  ledgerContext: {},
  isLedgerActivityLoading: isLedgerActivityLoading.initialState,
  ledgerActivity: [],
  loyalty: {},
  transactionId: transactionId.initialState,
  isPDPPointsTotalLoading: isPDPPointsTotalLoading.initialState,
  pdpPointsTotal: pdpPointsTotal.initialState,
  isLoyaltyQuestTokenLoading: isLoyaltyQuestTokenLoading.initialState,
  loyaltyQuestToken: loyaltyQuestToken.initialState,
};

export const reducer = combineReducers({
  isLedgerContextLoading: isLedgerContextLoading.reducer,
  ledgerContext: ledgerContext.reducer,
  isLedgerActivityLoading: isLedgerActivityLoading.reducer,
  ledgerActivity: ledgerActivity.reducer,
  transactionId: transactionId.reducer,
  isPDPPointsTotalLoading: isPDPPointsTotalLoading.reducer,
  pdpPointsTotal: pdpPointsTotal.reducer,
  isLoyaltyQuestTokenLoading: isLoyaltyQuestTokenLoading.reducer,
  loyaltyQuestToken: loyaltyQuestToken.reducer,
});

export interface StoreState {
  isLedgerContextLoading: isLedgerContextLoading.StoreState;
  ledgerContext: ledgerContext.StoreState;
  isLedgerActivityLoading: isLedgerActivityLoading.StoreState;
  ledgerActivity: ledgerActivity.StoreState;
  transactionId: transactionId.StoreState;
  isPDPPointsTotalLoading: isPDPPointsTotalLoading.StoreState;
  pdpPointsTotal: pdpPointsTotal.StoreState;
  isLoyaltyQuestTokenLoading: isLoyaltyQuestTokenLoading.StoreState;
  loyaltyQuestToken: loyaltyQuestToken.StoreState;
}
